import { useState, useEffect } from 'react';
import { isDemoMode, demoEnrollmentsStore, seedDemoEnrollmentsIfEmpty } from '../utils/demo';

export const usePendingEnrollmentsCount = () => {
  const [count, setCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchPendingCount = async () => {
      try {
        setIsLoading(true);

        if (isDemoMode()) {
          // For demo mode, get count from demo enrollments store
          seedDemoEnrollmentsIfEmpty();
          const enrollments = demoEnrollmentsStore.readAll();
          // In demo mode, all enrollments are considered pending
          setCount(enrollments.length);
        } else {
          // For production, you would integrate with your actual enrollments API here
          // For now, we'll use a placeholder count
          setCount(0);
        }
      } catch (error) {
        console.error('Error fetching pending enrollments count:', error);
        setCount(0);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPendingCount();

    // Set up an interval to periodically check for updates
    // In a real app, you might use WebSockets or other real-time updates
    const interval = setInterval(fetchPendingCount, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, []);

  return { count, isLoading };
};